<template>
  <div v-if="!pageMode" style="width: 100%;">
    <el-select
      ref="selectRef"
      v-load-more="loadMoreFn"
      v-model="innerValue"
      clearable
      filterable
      remote
      :remote-method="debounceSearch"
      :multiple="mulitiple"
      :placeholder="placeholder"
      :style="style"
      :loading="isSearching"
      loadingText="ロード中"
      noMatchText="データなし"
      noDataText="データなし"
      @focus="isFocused = true"
      @blur="isFocused = false;searchQuery = ''"
      @change="selectItem"
      :disabled="disabled"
    >
      <el-option
        v-for="item in (isMove ? internalOptions : options)"
        :key="item.id"
        :label="showId ? `${item[valueKey]} ${item[labelKey]}`: item[labelKey]"
        :value="item[valueKey]"
        :disabled="isMergeMovie && (disableList.includes(item[valueKey]))">
      </el-option>
    </el-select>
    <SearchType v-if="isShowSearchType" v-model:searchType="searchType" @search="searchTrigger(searchQuery)" style="margin-top: 10px;" />
  </div>
  <el-row justify="start" align="middle" v-else>
    <el-col :span="isShowSearchType ? 10 : 24">
      <el-select
        ref="selectRef"
        v-load-more="loadMoreFn"
        v-model="innerValue"
        clearable
        filterable
        remote
        :remote-method="debounceSearch"
        :multiple="mulitiple"
        :placeholder="placeholder"
        :style="style"
        :loading="isSearching"
        loadingText="ロード中"
        noMatchText="データなし"
        noDataText="データなし"
        @focus="isFocused = true"
        @blur="isFocused = false;searchQuery = ''"
        @change="selectItem"
        :disabled="disabled"
      >
        <el-option
          v-for="item in (isMove ? internalOptions : options)"
          :key="item.value"
          :label="showId ? `${item[valueKey]} ${item[labelKey]}`: item[labelKey]"
          :value="item[valueKey]"
          :disabled="isMergeMovie && (disableList.includes(item[valueKey]))">
        </el-option>
      </el-select>
    </el-col>
    <el-col v-if="isShowSearchType" :span="13" style="margin-left: 10px;">
      <SearchType v-model:searchType="searchType" @search="searchTrigger(searchQuery)" />
    </el-col>
  </el-row>
</template>
<script setup>
import {
  onBeforeUpdate, computed,
  toRefs,
  ref, watch, getCurrentInstance, nextTick,
} from 'vue';
import { dynamicallyAddMapping } from '@/assets/js/common.js';

const { proxy } = getCurrentInstance();

const props = defineProps({
  modelValue: {
    type: [String, Number, Array],
    default: '',
  },
  list: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
    default: null,
  },
  fetchOptions: {
    type: Function,
    required: true,
  },
  debounceDelay: {
    type: Number,
    default: 500,
  },
  searchKey: {
    type: String,
    default: '',
  },
  labelKey: {
    type: String,
    default: '',
  },
  valueKey: {
    type: String,
    default: '',
  },
  style: {
    type: Object,
    default: { width: '240px' },
  },
  mulitiple: {
    type: Boolean,
    default: false,
  },
  isSPLabel: {
    type: Boolean,
    default: false,
  },
  isMergeMovie: {
    type: Boolean,
    default: false,
  },
  mergeType: {
    type: Number,
    default: 1,
  },
  showId: {
    type: Boolean,
    default: false,
  },
  isMove: {
    type: Boolean,
    default: false,
  },
  tempId: {
    type: Number,
    default: null,
  },

  disableList: {
    type: Array,
    default: () => [],
  },
  isSchedule: {
    type: Boolean,
    default: false,
  },
  updateType: {
    type: String,
    default: '',
  },
  isForCrewing: {
    type: Boolean,
    default: false,
  },
  objType: {
    type: String,
    default: 'MOVIE',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isShowSearchType: {
    type: Boolean,
    default: false,
  },
  pageMode: {
    type: Boolean,
    default: false,
  },
});

const propsList = computed(() => props.list);
const emit = defineEmits(['update:modelValue', 'selectChange', 'syncOption', 'change']);

const innerValue = ref(props.modelValue);
const options = ref(props.list);
const currentPage = ref(1);
const totalItems = ref(0);
const loadMoreLoading = ref(false);
const isSearching = ref(false);
const searchQuery = ref('');
const selectRef = ref(null);
const isFocused = ref(false);
const selectedList = ref([]);
const searchType = ref('1');

// 动态添加key value
function dynamicallyAdd(keys, obj) {
  const _obj = {};
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    _obj[key] = key === 'name' || key === 'title' ? `${obj[key]}(${obj.id})` : obj[key];
  }
  return _obj;
}

watch(() => props.modelValue, (newVal) => {
  innerValue.value = newVal;
});
watch(() => props.list, (newVal, oldVal) => {
  if (newVal.length > 0) {
    if (currentPage.value === 1) currentPage.value++;
    if (!props.isMergeMovie) {
      options.value = proxy.$_.uniqBy([...selectedList.value,
        ...newVal.map((item) => ({
          [props.valueKey]: item[props.valueKey],
          [props.labelKey]: props.isSPLabel ? `${item[props.labelKey]}(${item[props.valueKey]})` : item[props.labelKey],
          openDate: item.openDate,
          openDateType: item.openDateType,
        }))], props.valueKey);
    } else {
      options.value = proxy.$_.uniqBy([...selectedList.value,
        ...newVal.map((item) => ({
          id: item.id,
          ...dynamicallyAdd(dynamicallyAddMapping[props.objType], item),
        }))]);
    }
  }
}, { immediate: true, deep: true });
watch(innerValue, (newVal) => {
  emit('update:modelValue', newVal);
});
const internalOptions = computed(() => props.list);
// 选择item
function selectItem(val) {
  emit('change', val);
  const targetItem = options.value.find((item) => item.id === val);
  if (props.isMergeMovie) {
    emit('selectChange', targetItem);
  } else if (proxy.$attrs.onUpdateList) {
    if (targetItem === undefined) return;
    proxy.$attrs.onUpdateList(props.updateType, targetItem);
  }
  if (!props.mulitiple) return;
  selectedList.value = [];
  val.forEach((id) => {
    const target = options.value.find((item) => item[props.valueKey] === id);
    if (target) {
      selectedList.value.push(target);
    }
  });
}
// 重置滚动条
function resetScrollPosition() {
  // 延迟执行以确保 DOM 更新
  nextTick(() => {
    const trigger = proxy.$refs.selectRef.$el.querySelector('.select-trigger');
    const id = trigger.getAttribute('aria-describedby');
    if (id) {
      const popper = document.getElementById(id);
      const selectWrap = popper.querySelector(
        '.el-scrollbar .el-select-dropdown__wrap',
      );
      selectWrap.scrollTop = 0;
    }
  });
}

// 关键字搜索
const debounceSearch = proxy.$_.debounce(async (query) => {
  resetScrollPosition();
  if (!isFocused.value) return;
  if (!props.mulitiple && !query) return;
  isSearching.value = true;
  searchQuery.value = query;
  currentPage.value = 1;
  // 搜索已选择的数据
  await props.fetchOptions({
    ...query ? {
      // [props.searchKey]: query,
      ...props.isShowSearchType && searchType.value === '2' ? { titleEqual: query } : { [props.searchKey]: query },
    } : {},
    pageNum: 1,
    pageSize: 20,
    ...((props.isMergeMovie && props.mergeType) || (props.isSchedule && props.searchKey === 'title')) ? { mergeType: props.mergeType } : {},
  }).then((response) => {
    // 兼容 response 为数组或 response.rows 两种情况
    const dataList = Array.isArray(response) ? response : (response.rows || []);
    if (!props.isMergeMovie) {
      if (props.isForCrewing) {
        options.value = [...proxy.$_.uniqBy([...selectedList.value,
          ...dataList.map((item) => ({ [props.valueKey]: item[props.valueKey], [props.labelKey]: props.isSPLabel ? `${item[props.labelKey]}(${item[props.valueKey]})` : item[props.labelKey] }))], props.valueKey)];
      } else {
        options.value = proxy.$_.uniqBy([...selectedList.value,
          ...dataList.map((item) => ({
            [props.valueKey]: item[props.valueKey],
            [props.labelKey]: props.isSPLabel ? `${item[props.labelKey]}(${item[props.valueKey]})` : item[props.labelKey],
            openDate: item.openDate,
            openDateType: item.openDateType,
          }))], props.valueKey);
      }
      if (props.isMove) {
        emit('syncOption', options.value, props.tempId);
      }
    } else {
      options.value = proxy.$_.uniqBy([...selectedList.value,
        ...dataList.map((item) => ({
          id: item.id,
          ...dynamicallyAdd(dynamicallyAddMapping[props.objType], item),
        }))]);
    }
    // if (proxy.$attrs.onUpdateList) {
    //   // 如果是scheduleAdd页面 同步跟新传进来的list
    //   proxy.$attrs.onUpdateList(props.updateType, options.value);
    // }
    totalItems.value = response.total || (Array.isArray(response) ? response.length : 0);
    currentPage.value += 1;
    isSearching.value = false;
  });
}, 300);
// list懒加载
function loadMoreFn() {
  if (isSearching.value) return;
  if (loadMoreLoading.value || (totalItems.value && totalItems.value <= options.value.length)) return;
  loadMoreLoading.value = true;
  props.fetchOptions({
    // ...searchQuery.value ? {
    //   [props.searchKey]: searchQuery.value,
    // } : {},
    ...searchQuery.value ? {
      // [props.searchKey]: query,
      ...props.isShowSearchType && searchType.value === '2' ? { titleEqual: searchQuery.value } : { [props.searchKey]: searchQuery.value },
    } : {},
    pageNum: currentPage.value,
    pageSize: 20,
    ...((props.isMergeMovie && props.mergeType) || (props.isSchedule && props.searchKey === 'title')) ? { mergeType: props.mergeType } : {},
  }).then((response) => {
    // 兼容 response 为数组或 response.rows 两种情况
    const dataList = Array.isArray(response) ? response : (response.rows || []);
    if (!props.isMergeMovie) {
      options.value = proxy.$_.uniqBy([...options.value,
        ...dataList.map((item) => ({
          [props.valueKey]: item[props.valueKey],
          [props.labelKey]: props.isSPLabel ? `${item[props.labelKey]}(${item[props.valueKey]})` : item[props.labelKey],
          openDate: item.openDate,
          openDateType: item.openDateType,
        }))], props.valueKey);
      if (props.isMove) {
        emit('syncOption', options.value, props.tempId);
      }
    } else {
      options.value = proxy.$_.uniqBy([...options.value,
        ...dataList.map((item) => ({
          id: item.id,
          ...dynamicallyAdd(dynamicallyAddMapping[props.objType], item),
        }))]);
    }
    // if (proxy.$attrs.onUpdateList) {
    //   // 如果是scheduleAdd页面 同步跟新传进来的list
    //   proxy.$attrs.onUpdateList(props.updateType, options.value.find(((item) => item[props.valueKey] === )));
    // }
    totalItems.value = response.total || (Array.isArray(response) ? response.length : 0);
    currentPage.value++;
    loadMoreLoading.value = false;
  });
}
// 切换searchType请求api
const searchTrigger = proxy.$_.debounce(async (query) => {
  await props.fetchOptions({
    ...query ? {
      // [props.searchKey]: query,
      ...props.isShowSearchType && searchType.value === '2' ? { titleEqual: query } : { [props.searchKey]: query },
    } : {},
    pageNum: 1,
    pageSize: 20,
    ...((props.isMergeMovie && props.mergeType) || (props.isSchedule && props.searchKey === 'title')) ? { mergeType: props.mergeType } : {},
  }).then((response) => {
    // 兼容 response 为数组或 response.rows 两种情况
    const dataList = Array.isArray(response) ? response : (response.rows || []);
    if (!props.isMergeMovie) {
      if (props.isForCrewing) {
        options.value = [...proxy.$_.uniqBy([...selectedList.value,
          ...dataList.map((item) => ({ [props.valueKey]: item[props.valueKey], [props.labelKey]: props.isSPLabel ? `${item[props.labelKey]}(${item[props.valueKey]})` : item[props.labelKey] }))], props.valueKey)];
      } else {
        options.value = proxy.$_.uniqBy([...selectedList.value,
          ...dataList.map((item) => ({ [props.valueKey]: item[props.valueKey], [props.labelKey]: props.isSPLabel ? `${item[props.labelKey]}(${item[props.valueKey]})` : item[props.labelKey] }))], props.valueKey);
      }
      if (props.isMove) {
        emit('syncOption', options.value, props.tempId);
      }
    } else {
      options.value = proxy.$_.uniqBy([...selectedList.value,
        ...dataList.map((item) => ({
          id: item.id,
          ...dynamicallyAdd(dynamicallyAddMapping[props.objType], item),
        }))]);
    }
    // if (proxy.$attrs.onUpdateList) {
    //   // 如果是scheduleAdd页面 同步跟新传进来的list
    //   proxy.$attrs.onUpdateList(props.updateType, options.value);
    // }
    totalItems.value = response.total || (Array.isArray(response) ? response.length : 0);
    currentPage.value += 1;
    isSearching.value = false;
  });
}, 500);
</script>
